import script from "./BodySubReview.vue?vue&type=script&setup=true&lang=js"
export * from "./BodySubReview.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodySubReview.vue?vue&type=style&index=0&id=323b710b&module=review&lang=css"
cssModules["review"] = style0
import "./BodySubReview.vue?vue&type=style&index=1&id=323b710b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-323b710b"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';import ScrollFire from 'quasar/src/directives/ScrollFire.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QAvatar,QImg});qInstall(script, 'directives', {ScrollFire});
